
// import * as React from 'react';
// import Box from '@mui/material/Box';
// import Stepper from '@mui/material/Stepper';
// import Step from '@mui/material/Step';
// import StepLabel from '@mui/material/StepLabel';
// import Button from '@mui/material/Button';
// import Typography from '@mui/material/Typography';
// import FirstPage from './FirstPage';
// import SecondPage from './SecondPage';
// import ThirdPage from './ThirdPage';
// import UserMasterHeader from '../UserCommonComponent/UserMasterHeader';
// import Row from 'react-bootstrap/Row';
// import beforelogo from '../../assets/registration-before.png';
// import afterlogo from '../../assets/login-after.png';
// import UserMasterFooter from '../UserCommonComponent/UserMasterFooter';
// import '../../UserComponents/UserComponent.css';
// import { useLocation, useNavigate } from 'react-router-dom';
// import { useEffect } from 'react';
// import HeaderPage from '../../NewLoginPage/HeaderPage';

// const steps = ['Personal Information', 'Expectations about spouse', 'Photo'];

// export default function StepperForm() {

//    // Scroll to the top when component is mounted
//    useEffect(() => {
//     window.scrollTo(0, 0);
//   }, []);

//   const navigate = useNavigate();
//   const location = useLocation();
//   const state = location.state?.state;
//   const userStatus = JSON.parse(sessionStorage.getItem("status")); // Replace with actual logic to fetch user status.
 
//   // Define the initial step based on the user's status.
//   const initialStep = () => {
//     if (state === undefined) {
//       switch (userStatus) {
//         case 3:
//           return 0;
//         case 4:
//           return 1;
//         case 5:
//           return 2;
//         default:
//           return 0; // Default to the first page for other statuses.
//       }
//     } else {
//       return 0;
//     }
//   };

//   const [activeStep, setActiveStep] = React.useState(initialStep);
//   const [skipped, setSkipped] = React.useState(new Set());
//   const [firstPageSubmitted, setFirstPageSubmitted] = React.useState(false);
//   const [SecondPageSubmitted, setSecondPageSubmitted] = React.useState(false);
//   const [ThirdPageSubmitted, setThirdPageSubmitted] = React.useState(false);

//   //submit first page
//   const handleFirstPageSubmit = () => {
//     setFirstPageSubmitted(true);
//     handleNext(); // Move to the next step
//   };




//   const handleSecondPageSubmit = () => {
//     setSecondPageSubmitted(true);
//     handleNext(); // Move to the next step
//   };
//   const handleThirdPageSubmit = () => {
//     setThirdPageSubmitted(true);
//     navigate('/payment') // Move to the next step
//   };

//   const isStepOptional = (step) => {
//     return step === 1;
//   };

//   const isStepSkipped = (step) => {
//     return skipped.has(step);
//   };

//   const handleNext = () => {
//     let newSkipped = skipped;
//     if (isStepSkipped(activeStep)) {
//       newSkipped = new Set(newSkipped.values());
//       newSkipped.delete(activeStep);
//     }

//     setActiveStep((prevActiveStep) => prevActiveStep + 1);
//     setSkipped(newSkipped);
//   };

//   const handleBack = () => {
//     setActiveStep((prevActiveStep) => prevActiveStep - 1);
//   };

//   const handleSkip = () => {
//     if (!isStepOptional(activeStep)) {
//       throw new Error("You can't skip a step that isn't optional.");
//     }

//     setActiveStep((prevActiveStep) => prevActiveStep + 1);
//     setSkipped((prevSkipped) => {
//       const newSkipped = new Set(prevSkipped.values());
//       newSkipped.add(activeStep);
//       return newSkipped;
//     });
//   };

//   const handleReset = () => {
//     setActiveStep(0);
//   };

//   return (
//     <div>
//     <div><HeaderPage /></div>
//     <div className='stepper-container  p-md-4 pt-3'  >
//     <Box sx={{ width: '100%' }}>
//     <Row className='mb-3 m-0'>
//          <div style={{ display: "flex", justifyContent: "center" }}>
//            <img src={beforelogo} height={30} />
//          </div>
//          <h3 className='mt-1 mb-0 pb-1' style={{ color: "rgb(134, 28, 18)",display: "flex", justifyContent: "center" }}><b>Registration Form</b></h3>
//          <div style={{ display: "flex", justifyContent: "center" }}>
//            <img src={afterlogo} />
//          </div>
      
//        </Row>
//       <Stepper activeStep={activeStep} className='main-step stepper-container'>
//         {steps.map((label, index) => {
//           const stepProps = {};
//           const labelProps = {};
//           if (isStepSkipped(index)) {
//             stepProps.completed = false;
//           }
//           return (
//             <Step key={label} {...stepProps}>
//               <StepLabel {...labelProps}>{label}</StepLabel>
//             </Step>
//           );
//         })}
//       </Stepper>
//       {activeStep === steps.length ? (
//         <React.Fragment>
//           <Typography sx={{ mt: 5, mb: 1, textAlign: 'center' }}>
//             <h3><b>All steps completed</b></h3> 
//           </Typography>
//           <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
//             <Box sx={{ flex: '1 1 auto' }} />
//             <Button onClick={handleReset} style={{padding:"7px 19px", backgroundColor:"rgb(134, 28, 18)",border:"0px",color:"white",fontSize:"20px"}} >submit</Button>
//           </Box>
//         </React.Fragment>
//       ) : (
//         <React.Fragment>
//         {activeStep === 0 && <FirstPage onSubmit={handleFirstPageSubmit}/>}
//         {activeStep === 1 && <SecondPage onSubmit={handleSecondPageSubmit} />}
//         {activeStep === 2 && <ThirdPage onSubmit={handleThirdPageSubmit} /> }
         
//          { state === 1 ? ( <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
//             <Button
//               color="inherit"
//               disabled={activeStep === 0}
//               onClick={handleBack}
//               sx={{ mr: 1 }}
//               className='backbtn'
//             >
//               Back
//             </Button>
//             <Box sx={{ flex: '1 1 auto' }} />
//             {isStepOptional(activeStep) && (
//               <Button color="inherit" onClick={handleSkip} sx={{ mr: 1 }}>
//                 {/* Skip */}
//               </Button>
//             )}

//             <Button onClick={handleNext} className={ activeStep === 2 ? '': 'nextbtn'} disabled={activeStep === 2 }
            
//               // style={{
//               // backgroundColor: 'blue',
//               // color: 'white',
//               // borderRadius: '5px',}}
//               >   
//               {activeStep === steps.length - 1 ? '' : 'Next'}
//             </Button>
//           </Box>
//          ):null }
//         </React.Fragment>
//       )}
//     </Box>
//     </div>
//     <div>
//      <UserMasterFooter />
//     </div>
    
//     </div>
//   );
// }

import React, { useEffect, useState } from 'react';
import { Steps, Button, Typography, Card, Row, Col } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';
import FirstPage from './FirstPage';
import ThirdPage from './ThirdPage'; // Photo Page
import UserMasterFooter from '../UserCommonComponent/UserMasterFooter';
import HeaderPage from '../../NewLoginPage/HeaderPage';
import beforelogo from '../../assets/registration-before.png';
import afterlogo from '../../assets/login-after.png';
import '../../UserComponents/UserComponent.css';

const { Step } = Steps;
const { Title } = Typography;

const steps = [
  { title: 'Personal Information' },
  { title: 'Photo' },
];

const StepperForm = () => {
  useEffect(() => window.scrollTo(0, 0), []);

  const navigate = useNavigate();
  const location = useLocation();
  const state = location.state?.state;
  const userStatus = JSON.parse(sessionStorage.getItem('status'));

  const initialStep = () => {
    if (state === undefined) {
      switch (userStatus) {
        case 3:
        case 4:
          return 0;
        case 5:
          return 1;
        default:
          return 0;
      }
    } else {
      return 0;
    }
  };

  const [current, setCurrent] = useState(initialStep);

  const handleFirstPageSubmit = () => {
    setCurrent(1);
  };

  const handleThirdPageSubmit = () => {
    navigate('/payment');
  };

  const prev = () => setCurrent((prev) => prev - 1);

  const renderStepContent = () => {
    switch (current) {
      case 0:
        return <FirstPage onSubmit={handleFirstPageSubmit} />;
      case 1:
        return <ThirdPage onSubmit={handleThirdPageSubmit} />;
      default:
        return null;
    }
  };

  return (
    <div className="stepper-wrapper">
      <HeaderPage />

      <div className="container-fluid px-lg-5 py-2">

        <Card className="stepper-card shadow">
        
          <Title level={3} className="title">
            Registration Form
          </Title>

          <Steps current={current} className="custom-steps border px-3 py-1" responsive>
            {steps.map((item) => (
              <Step key={item.title} title={item.title}/>
            ))}
          </Steps>

          <div className="step-content">{renderStepContent()}</div>

          {state === 1 && (
            <div className="step-buttons">
              <Row justify="space-between">
                <Col>
                  <Button
                    disabled={current === 0}
                    onClick={prev}
                    className="back-button"
                  >
                    Back
                  </Button>
                </Col>
              </Row>
            </div>
          )}

        </Card>

      </div>

      <UserMasterFooter />
    </div>
  );
};

export default StepperForm;
